/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in popup Order008
 * @created at      :   2026/02/09
 * @created by      :   longvv
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
import repository from './repository';

const dataInit = {
    mode: 0,
    company_cd: '',
    company_name: '',
    department_cd: '',
    department_name: '',
    customer_name: '',
    status: '',
    creator: '',
    keyword: '',
    expired_estimate: '0',
    estimate_date_start: '',
    estimate_date_end: '',
    working_date_start: '',
    working_date_end: ''
};

const MSG_NO_DATA = '該当するデータが存在しません。';

export default {
    namespaced: true,
    state: {
        data: { ...dataInit },
        searchData: [],
        options: {
            status: [],
            expiredEstimate: [
                {
                    code: '1',
                    name: '非表示'
                },
                {
                    code: '0',
                    name: '表示'
                }
            ],
            pageSize: [
                { code: 0, name: '全件表示' },
                { code: 100, name: '100件' },
                { code: 50, name: '50件' }
            ]
        },
        paginationData: {
            pageNo: 1,
            pageSize: 100,
            totalRows: 0,
            msgNoData: MSG_NO_DATA
        }
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataInit };
            state.paginationData.pageNo = 1;
            state.paginationData.pageSize = 100;
            state.paginationData.totalRows = 0;
            state.paginationData.msgNoData = MSG_NO_DATA;
            state.searchData = [];
        },
        setSearchData(state, data) {
            state.searchData = data ?? [];
        },
        setPageNavigation(state, data) {
            state.paginationData.pageNo = parseInt(data.page);
            state.paginationData.pageSize = parseInt(data.pageSize);
            state.paginationData.totalRows = parseInt(data.totalRows);
            state.paginationData.msgNoData = parseInt(data.totalRows) === 0 ? MSG_NO_DATA : '';
        },
        setCombobox(state, data) {
            state.options.status = data ?? [];
        }
    },
    actions: {
        actionSearch(context, param = {}) {
            try {
                const { callback, onError, ...requestParam } = param;
                repository.search(requestParam).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        context.commit('setSearchData', data.Data.data);
                        context.commit('setPageNavigation', data.Data.paging);
                        if (callback) {
                            callback(data);
                        }
                    } else if (onError) {
                        onError(data.Data?.message ?? data.Message);
                    }
                });
            } catch (e) {
                console.log('Search: ' + e.message);
            }
        }
    }
};
